import { Icon } from '@/components'
import styles from './AreaInfo.module.scss'

interface AreaInfoProps {
  name?: string
  address?: string
}

export const AreaInfo = ({ name, address }: AreaInfoProps) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.areaName}>{name}</h1>
      <p className={styles.address}>
        <Icon name="location-icon" />
        {address}
      </p>
    </div>
  )
}
